var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"NavMenu"},[_c('el-menu',{attrs:{"default-active":_vm.defaultActive,"default-openeds":_vm.defaultOpendeds},on:{"select":_vm.onSelect}},_vm._l((_vm.navMenus),function(menu){return _c('NavSubMenu',{key:menu.name,attrs:{"menu":menu}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }